import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from 'src/app/services/customer.service';
import { RgtService } from 'src/app/services/rgt.service';
import { PushNotificationService } from 'src/app/services/push-notification.service';
import { PreferencesService } from 'src/app/services/preferences.service';
import * as moment from 'moment';
import 'moment-timezone';
declare var $: any;
import { Select2Data, Select2UpdateEvent } from 'ng-select2-component';
import { AuthService } from 'src/app/services/auth.service';

interface ConnectionDataItem {
  label: string;
  value: string;
  icon: string;
}

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.css'],
})
export class CustomerDetailComponent implements OnInit {
  id: any;
  token: any;
  userInfo: any = [];
  datingInfo: any;
  userTranscationinfo: any;
  userPreference: any;
  userSubscription: any;
  userImages: any;
  userChart: any;
  userEdu: any;
  userprofession: any;
  subscriptionFeatures: any;
  status: any;
  personalDetails: any;
  attractivenessScore: number | undefined;
  activityScore: number | undefined;
  info: any;
  item: any;
  aboutYourself: any;
  profileStatus: any;
  socialDetails: any;
  newConnectionsSummary: any = null;
  addnotificationForm!: FormGroup;
  submitted = false;
  registrationTime: any;
  userType = 'Specific';
  uploadImg: any;
  referralCount: any;
  type: any = '';
  dataMeet: any;
  showDiv = false;
  meetList: any = [];
  matchData: any = [];
  marketStatus: any;
  accessVal: any = false;
  tier: any = '';
  voice_prompt: string = '';
  dataTiersList: Select2Data = [];
  next_user_id: number | undefined;
  prev_user_id: number | undefined;
  display_reject_approve_buttons: boolean = true;
  userMovedToTier2: boolean = false;
  connectionDataItems: ConnectionDataItem[] = [];
  loadingConnectionDataItems: boolean = true;

  private readonly connectionDataIconMap: Record<string, string> = {
    $device_id: 'fa fa-mobile',
    device_id: 'fa fa-mobile',
    pass_stage: 'fa fa-flag',
    total_connections_given: 'fa fa-exchange',
    total_connections_left: 'fa fa-link',
    total_active_left: 'fa fa-bolt',
    total_values_left: 'fa fa-star',
    total_general_left: 'fa fa-list',
    total_attractive_left: 'fa fa-heart',
  };

  // Add properties for editing customer details
  editCustomerForm!: FormGroup;
  editSubmitted = false;
  isEditing = false;

  // Add properties to store filter data
  filterData: any = null;
  searchTerm: string = '';
  fromDate: string = '';
  toDate: string = '';
  currentPage: number = 1;
  userStatus: string = '';
  totalItems: number = 10;

  rejectModalId: string = 'rejectUserDetailModal';
  approveModalId: string = 'approveUserDetailModal';
  unApproveModalId: string = 'unApproveUserDetailModal';
  tier2ApproveModalId: string = 'tier2ApproveUserDetailModal';
  rejectEmitter = new EventEmitter<'OPEN' | 'CLOSE'>();
  approveEmitter = new EventEmitter<'OPEN' | 'CLOSE'>();
  tier2ApproveEmitter = new EventEmitter<'OPEN' | 'CLOSE'>();
  unApproveEmitter = new EventEmitter<'OPEN' | 'CLOSE'>();

  connectionDetailsLoaded: boolean = false;
  isLoadingConnections: boolean = false;

  loadConnectionData() {
    this.token = localStorage['token'];
    this.isLoadingConnections = true;
    this.customerService.getConnectionDetails(this.id, this.token).subscribe({
      next: (res: any) => {
        if (res && res.status == 200) {
          this.newConnectionsSummary = res.data;
          this.connectionDetailsLoaded = true;
          this.toastr.success(res.message);
        } else {
          this.toastr.error(res.message || 'Failed to load connection details');
        }
        this.isLoadingConnections = false;
      },
      error: (error) => {
        this.isLoadingConnections = false;
        this.toastr.error(error.error?.message || 'Error loading connection details');
      }
    });
  }

  openRejectModal() {
    this.rejectEmitter.emit('OPEN');
  }

  openApproveModal() {
    this.approveEmitter.emit('OPEN');
  }

  openTier2ApproveModal() {
    this.tier2ApproveEmitter.emit('OPEN');
  }

  openUnapproveModal() {
    this.unApproveEmitter.emit('OPEN');
  }

  moveToNextUser() {
    let path = '/customer-detail';
    // Preserve filter state when navigating
    const navigationState = {
      filters: this.filterData,
      search: this.searchTerm,
      fromdate: this.fromDate,
      todate: this.toDate,
      currentPage: this.currentPage,
      userStatus: this.userStatus,
      totalItems: this.totalItems,
    };

    this.router.navigate([path, this.next_user_id, this.status], {
      state: navigationState,
    });
  }

  moveToPrevUser() {
    let path = '/customer-detail';
    // Preserve filter state when navigating
    const navigationState = {
      filters: this.filterData,
      search: this.searchTerm,
      fromdate: this.fromDate,
      todate: this.toDate,
      currentPage: this.currentPage,
      userStatus: this.userStatus,
      totalItems: this.totalItems,
    };

    this.router.navigate([path, this.prev_user_id, this.status], {
      state: navigationState,
    });
  }

  // Add method to navigate back to customer list with preserved filters
  navigateBackToList() {
    if (this.filterData) {
      // Navigate back with filter state
      this.router.navigate(['/customers-list'], {
        state: {
          filters: this.filterData,
          search: this.searchTerm,
          fromdate: this.fromDate,
          todate: this.toDate,
          currentPage: this.currentPage,
          userStatus: this.userStatus,
          totalItems: this.totalItems,
        },
      });
    } else {
      // Fallback to normal navigation
      this.router.navigate(['/customers-list']);
    }
  }

  rejectUser(event: { reason: string; action: string }) {
    const { action, reason } = event;
    let obj = {
      id: this.id,
      action,
      reason,
    };

    this.customerService.updateUserApproval(obj, this.token).subscribe({
      next: (res: any) => {
        if (res.status == 200) {
          this.toastr.success(res.message);
          this.rejectEmitter.emit('CLOSE');
          this.display_reject_approve_buttons = false;
        }
      },
      error: (error) => {
        this.toastr.error(
          error.error?.message || 'Failed to update user approval'
        );
      },
    });
  }

  constructor(
    public router: Router,
    private customerService: CustomerService,
    private rgtService: RgtService,
    private toastr: ToastrService,
    private activateroute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private pushnotification: PushNotificationService,
    private preferencesService: PreferencesService,
    private authService: AuthService
  ) { }

  public get isManager(): boolean {
    return this.authService.isManager;
  }

  ngOnInit(): void {
    this.activateroute.params.subscribe((params) => {
      this.id = this.activateroute.snapshot.paramMap.get('id');
      this.status = this.activateroute.snapshot.paramMap.get('status');

      // Retrieve navigation state with filter data
      const state = history.state;
      if (state && state.filters) {
        this.filterData = state.filters;
        this.searchTerm = state.search || '';
        this.fromDate = state.fromdate || '';
        this.toDate = state.todate || '';
        this.currentPage = state.currentPage || 1;
        this.userStatus = state.userStatus || '';
        this.totalItems = state.totalItems || 10;

        console.log('Filter data received:', this.filterData);
        console.log('Search term:', this.searchTerm);
        console.log('Current page:', this.currentPage);
      }

      this.addnotificationForm = this.formBuilder.group({
        Title: ['', Validators.required],
        Body: ['', Validators.required],
      });

      // Initialize the edit customer form
      this.editCustomerForm = this.formBuilder.group({
        name: [''],
        occupation: [''],
        connection_pitch: [''],
      });

      this.userDetail();
      this.meetData();
      // reinitialize variables here, as angular does not rerender same route with different param
      this.display_reject_approve_buttons = true;
      this.userMovedToTier2 = false;
      this.connectionDetailsLoaded = false;
      this.newConnectionsSummary = null;
    });
  }

  get addf() {
    return this.addnotificationForm.controls;
  }

  // using fetchApproved to fetch approved user details after scouting user in the unapproved list
  userDetail(fetchApproved = false) {
    this.token = localStorage['token'];
    this.loadingConnectionDataItems = true;
    //approved user
    // For tier2, send UNAPPROVED as action
    const action =
      this.userStatus === 'tier2'
        ? 'UNAPPROVED'
        : this.userStatus === 'auto-rejected'
          ? 'AUTO-REJECTION'
          : this.userStatus;

    this.customerService
      .viewCustomerDetail(
        this.id,
        {
          ...this.extractIdsFromFilterData(this.filterData),
          action: action,
        },
        this.token
      )
      .subscribe((res: any) => {
        if (res && res.status == 200) {
          this.userSubscription = res.data.subscription;
          this.referralCount = res.data.total_referral;
          this.aboutYourself = res.data.aboutYourself;
          this.userImages = res.data.uploads.best_photos;
          this.personalDetails = res.data.personalDetails;
          this.attractivenessScore = res.data.attractivenessScore;
          this.activityScore = res.data.activityScore;
          this.marketStatus = res.data.subscribedEmail;
          this.info = res.data.info;
          this.connectionDataItems = this.buildConnectionDataItems(
            this.info?.connectionData
          );
          this.datingInfo = res.data.datingData;
          // this.newConnectionsSummary = res.data.newConnections; // Loaded on demand now
          if (!fetchApproved) {
            this.next_user_id = res.data.next_user_id;
            this.prev_user_id = res.data.prev_user_id;
          }
          this.personalDetails.registrationDate = moment(
            this.personalDetails.registrationDate
          )
            .tz('Asia/Dubai')
            .format('YYYY-MM-DD HH:mm:ss');
          this.profileStatus = res.data.idVerification;
          this.socialDetails = res.data.socialConnect;


          if (this.personalDetails?.lastLogin) {
            this.personalDetails.lastLogin = moment(
              this.personalDetails.lastLogin
            )
              .tz('Asia/Dubai')
              .format('YYYY-MM-DD HH:mm:ss');
          }
        } else {
        }
        this.loadingConnectionDataItems = false;
      });
  }

  openApprovedUnapprovedUserModal() {
    $('#approveUnapproved').show();
  }

  getAccess(event: any) {
    this.accessVal = event.target.checked;
    console.log(this.accessVal, 'Access');
  }

  approveUser() {
    let obj = {
      id: this.id,
      tier: 'TIER1',
    };
    this.token = localStorage['token'];
    this.customerService
      .approvedUnapproved(obj, this.token)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.toastr.success(res.message);
          this.approveEmitter.emit('CLOSE');
          this.display_reject_approve_buttons = false;
          this.tier = 'TIER1';
          this.personalDetails.tier_name = 'TIER1';
        }
      });
  }

  approveTier2Unapprovedf() {
    let obj = {
      id: this.id,
      tier: 'TIER2',
    };
    this.token = localStorage['token'];
    this.customerService
      .approvedUnapproved(obj, this.token)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.tier = 'TIER2';
          this.personalDetails.tier_name = 'TIER2';
          this.toastr.success(res.message);
          this.tier2ApproveEmitter.emit('CLOSE');
          this.display_reject_approve_buttons = false;
        }
      });
  }

  matchStatus(event: any) {
    this.type = event.target.value;
    if (this.type == 'mutual') {
      this.showDiv = !this.showDiv;
    } else {
      this.showDiv = false;
    }
    this.meetData();
  }

  meetinfoData(item: any) {
    this.matchData = item.meet;
  }
  meetData() {
    let obj = {
      type: this.type,
    };
    this.token = localStorage['token'];
    this.customerService
      .customerMeetList(this.id, obj, this.token)
      .subscribe((res: any) => {
        if (res && res.status == 200) {
          this.dataMeet = res.data;
          this.meetList = res.data.meet;
        } else {
        }
      });
  }

  imageData(event: any, item: any) {
    this.uploadImg = item;
    $('#uploadImg').show();
    console.log(this.uploadImg, 'this.uploadImg');
  }

  changeStatus(event: any, item: any) {
    let obj = {
      id: item.user_id,
      status: this.userInfo.status == 'Inactive' ? 'Active' : 'Inactive',
    };
    this.customerService
      .customerStatus(obj, this.token)
      .subscribe((res: any) => {
        if (res.status == 'Active') {
        } else if (res.status == 'Inactive') {
        }
        this.userDetail();
      });
  }

  updateTier(event: Select2UpdateEvent) {
    this.tier = event.value;
  }

  formatData(data: any[]): string {
    if (!data || data.length === 0) {
      return 'N/A';
    }

    if (typeof data === 'string') {
      return data;
    }

    const names = data.map((item) => {
      if (typeof item === 'string') {
        return item;
      }
      return item.name;
    }).join(', ');
    return names;
  }

  getImage(data: any[]): string {
    if (data && data.length > 0 && data[0].image) {
      return data[0].image;
    } else {
      // Return a sample image URL
      return 'assets/images/about-icon.svg';
    }
  }

  connectionProfileId(item: any): number | string | null {
    if (!item) {
      return null;
    }

    if (
      item.other_user_id !== undefined &&
      item.other_user_id !== null &&
      item.other_user_id !== ''
    ) {
      return item.other_user_id;
    }

    if (
      item.user_id !== undefined &&
      item.user_id !== null &&
      item.user_id !== ''
    ) {
      return item.user_id;
    }

    return null;
  }

  connectionProfileUrl(
    otherUserId: number | string | null | undefined
  ): string {
    if (!otherUserId && otherUserId !== 0) {
      return '#';
    }

    const idParam = otherUserId;
    const statusParam =
      typeof this.status === 'string' && this.status.trim().length
        ? this.status
        : 'approved';

    return `/#/customer-detail/${idParam}/${statusParam}`;
  }

  capitalizeFirstLetterOfEachWord(input: string): string {
    if (!input || input.trim().length === 0) {
      return 'N/A';
    }

    // Replace underscores with spaces
    const replacedSpaces = input.replace(/_/g, ' ');

    // Capitalize the first letter of each word
    const capitalizedWords = replacedSpaces.replace(
      /\w\S*/g,
      function (txt: any) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
    return capitalizedWords;
  }

  private buildConnectionDataItems(
    connectionData: Record<string, any> | null | undefined
  ): ConnectionDataItem[] {
    if (!connectionData) {
      return [];
    }

    const items: ConnectionDataItem[] = [];

    Object.keys(connectionData).forEach((key) => {
      const rawValue = connectionData[key];
      if (rawValue === null || rawValue === undefined || rawValue === '') {
        return;
      }

      items.push({
        label: this.formatConnectionLabel(key),
        value: this.formatConnectionValue(key, rawValue),
        icon: this.connectionDataIconMap[key] || 'fa fa-info-circle',
      });
    });

    return items;
  }

  private formatConnectionLabel(key: string): string {
    if (!key) {
      return 'Unknown';
    }
    const cleanedKey = key.replace(/^\$+/, '').replace(/_/g, ' ').trim();
    if (!cleanedKey) {
      return 'Unknown';
    }
    return cleanedKey
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  private formatConnectionValue(key: string, value: any): string {
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    if (typeof value === 'number') {
      return value.toString();
    }
    if (typeof value === 'string') {
      if (key === 'pass_stage') {
        return this.capitalizeFirstLetterOfEachWord(value);
      }
      if (this.looksLikeDate(value)) {
        return this.formatDateString(value);
      }
      return value;
    }
    if (Array.isArray(value)) {
      return value.join(', ');
    }

    try {
      return JSON.stringify(value);
    } catch (error) {
      return String(value);
    }
  }

  private looksLikeDate(value: string): boolean {
    if (!value || typeof value !== 'string') {
      return false;
    }
    const isoDate = moment(value, moment.ISO_8601, true);
    if (isoDate.isValid()) {
      return true;
    }
    if (/^\d{10,13}$/.test(value)) {
      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) {
        return false;
      }
      if (value.length === 10) {
        return moment.unix(numericValue).isValid();
      }
      return moment(numericValue).isValid();
    }
    return false;
  }

  private formatDateString(value: string): string {
    const isoDate = moment(value, moment.ISO_8601, true);
    if (isoDate.isValid()) {
      return isoDate.tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss');
    }
    if (/^\d{10,13}$/.test(value)) {
      const numericValue = Number(value);
      if (Number.isNaN(numericValue)) {
        return value;
      }
      const numericDate =
        value.length === 10 ? moment.unix(numericValue) : moment(numericValue);
      if (numericDate.isValid()) {
        return numericDate.tz('Asia/Dubai').format('YYYY-MM-DD HH:mm:ss');
      }
    }
    return value;
  }

  formatDateOfBirth(dateOfBirth: string): string {
    if (!dateOfBirth) {
      return 'N/A';
    }

    try {
      const date = new Date(dateOfBirth);

      // Check if the date is valid
      if (isNaN(date.getTime())) {
        return 'N/A';
      }

      // Format date as YYYY-MM-DD
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      // Calculate age
      const today = new Date();
      let age = today.getFullYear() - date.getFullYear();
      const monthDiff = today.getMonth() - date.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < date.getDate())
      ) {
        age--;
      }

      return `${year}-${month}-${day} (${age} years)`;
    } catch (error) {
      return 'N/A';
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.addnotificationForm.invalid) {
      return;
    }
    this.token = localStorage['token'];
    // let index = this.id;
    // this.id.splice(index, 1);
    let obj = {
      title: this.addnotificationForm.get('Title')?.value,
      message: this.addnotificationForm.get('Body')?.value,
      user_type: this.userType,
      ids: this.id.split(),
    };
    this.pushnotification
      .pushnotificationAdd(obj, this.token)
      .subscribe((res: any) => {
        if (res && res.status == 200) {
          this.toastr.success(res.message);
          $('#deletModal').modal('hide');
          this.addnotificationForm.reset();
          // this.router.navigate(['/customer-list']);
          this.submitted = false;
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  onTierSubmit() {
    this.submitted = true;
    if (!this.tier) {
      return;
    }
    this.token = localStorage['token'];

    let obj = {
      id: this.id,
      tier: this.tier,
    };

    this.customerService
      .associateTier(obj, this.token)
      .subscribe((res: any) => {
        if (res && res.status == 200) {
          this.toastr.success(res.message);
          this.userDetail();
          this.submitted = false;
          $('#editTierModal').modal('hide');
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  openScoutModal() {
    $('#scoutModal').modal('show');
  }

  openEditCustomerModal() {
    // Update the form with the current values
    this.editCustomerForm.patchValue({
      name: this.personalDetails?.name || '',
      occupation: this.aboutYourself?.occupation || '',
      connection_pitch: this.aboutYourself?.connection_pitch || '',
    });

    this.editSubmitted = false;
    $('#editCustomerModal').modal('show');
  }

  openDeleteAudioModal() {
    $('#deleteAudioModal').modal('show');
  }

  openMoveToTier2Modal() {
    $('#moveToTier2Modal').modal('show');
  }

  removalReason: string = '';
  otherRemovalReason: string = '';

  openRemoveFromAutoApprovalModal() {
    this.removalReason = '';
    this.otherRemovalReason = '';
    $('#removeFromAutoApprovalModal').modal('show');
  }

  confirmRemoveFromAutoApproval() {
    if (!this.removalReason) {
      this.toastr.error('Please select a reason');
      return;
    }

    if (this.removalReason === 'Other' && !this.otherRemovalReason.trim()) {
      this.toastr.error('Please enter a reason');
      return;
    }

    this.token = localStorage['token'];
    const reasonToSend =
      this.removalReason === 'Other'
        ? this.otherRemovalReason
        : this.removalReason;

    const obj = {
      id: this.id,
      reason: reasonToSend,
    };

    this.customerService.removeFromAutoApproval(obj, this.token).subscribe({
      next: (res: any) => {
        if (res && res.status == 200) {
          this.toastr.success(res.message);
          $('#removeFromAutoApprovalModal').modal('hide');
          // Hide buttons and refresh or navigate back
          this.display_reject_approve_buttons = false;
        } else {
          this.toastr.error(
            res.message || 'Failed to remove from auto approval'
          );
        }
      },
      error: (error) => {
        console.error('Remove from auto approval error:', error);
        this.toastr.error(
          error.error?.message ||
          'An error occurred while removing from auto approval'
        );
      },
    });
  }

  confirmDeleteAudio() {
    this.token = localStorage['token'];
    const obj = {
      voice_prompt: true,
    };

    this.customerService
      .updateCustomerData(this.id, obj, this.token)
      .subscribe({
        next: (res: any) => {
          if (res && res.status == 200) {
            this.toastr.success(res.message);
            $('#deleteAudioModal').modal('hide');
            // Refresh user details to show updated data
            this.userDetail();
          } else {
            this.toastr.error(res.message || 'Failed to delete audio');
          }
        },
        error: (error) => {
          console.error('Delete audio error:', error);
          this.toastr.error(
            error.error?.message || 'An error occurred while deleting audio'
          );
        },
      });
  }

  confirmMoveToTier2() {
    this.token = localStorage['token'];
    const obj = {
      id: this.id,
      tier: 'TIER2',
    };

    this.customerService.associateTier(obj, this.token).subscribe({
      next: (res: any) => {
        if (res && res.status == 200) {
          this.toastr.success(res.message);
          $('#moveToTier2Modal').modal('hide');
          // Set flag to hide the button
          this.userMovedToTier2 = true;
        } else {
          this.toastr.error(res.message || 'Failed to move user to TIER2');
        }
      },
      error: (error) => {
        console.error('Move to TIER2 error:', error);
        this.toastr.error(
          error.error?.message || 'An error occurred while moving user to TIER2'
        );
      },
    });
  }

  get editf() {
    return this.editCustomerForm.controls;
  }

  onEditCustomerSubmit() {
    this.editSubmitted = true;
    if (this.editCustomerForm.invalid) {
      return;
    }

    this.token = localStorage['token'];
    let nameValue = this.editCustomerForm.get('name')?.value || '';
    let occupationValue = this.editCustomerForm.get('occupation')?.value || '';
    let connectionPitchValue =
      this.editCustomerForm.get('connection_pitch')?.value || '';

    const obj = {
      name: nameValue,
      occupation: occupationValue,
      connection_pitch: connectionPitchValue,
    };

    this.customerService
      .updateCustomerData(this.id, obj, this.token)
      .subscribe({
        next: (res: any) => {
          if (res && res.status == 200) {
            this.toastr.success(res.message);
            $('#editCustomerModal').modal('hide');
            this.editCustomerForm.reset();
            this.editSubmitted = false;
            // Refresh user details to show updated data
            this.userDetail();
          } else {
            this.toastr.error(res.message || 'Failed to update customer data');
          }
        },
        error: (error) => {
          console.error('Update customer error:', error);
          this.toastr.error(
            error.error?.message ||
            'An error occurred while updating customer data'
          );
        },
      });
  }

  confirmScoutMembership() {
    this.token = localStorage['token'];
    this.customerService
      .scoutMembership(
        { customer_ids: [this.id], is_approving: this.status === 'unapproved' },
        this.token
      )
      .subscribe({
        next: (res: any) => {
          if (res && res.status == 200) {
            this.toastr.success(res.message);
            $('#scoutModal').modal('hide');
            this.userDetail(true); // Refresh the user details
          } else {
            this.toastr.error(res.message || 'Failed to scout membership');
          }
        },
        error: (error) => {
          console.error('Scout membership error:', error);
          this.toastr.error(
            error.error?.message ||
            'An error occurred while scouting membership'
          );
          $('#scoutModal').modal('hide');
        },
      });
  }

  unapproveUser(event: { reason?: string; action: string }) {
    const { action, reason } = event;
    let obj = {
      id: this.id,
      action,
      reason,
    };

    this.customerService.updateUserApproval(obj, this.token).subscribe({
      next: (res: any) => {
        if (res.status == 200) {
          this.toastr.success(res.message);
          this.unApproveEmitter.emit('CLOSE');
          this.display_reject_approve_buttons = false;
        }
      },
      error: (error) => {
        this.toastr.error(error.error?.message || 'Failed to unapprove user');
      },
    });
  }

  // Helper method to count active filters
  getActiveFiltersCount(): number {
    return this.getActiveFilterChips().length;
  }

  // Helper method to extract only IDs from filter data for API calls
  extractIdsFromFilterData(filterData: any): any {
    if (!filterData) return filterData;

    const cleanedFilters = { ...filterData };

    // Extract IDs from arrays that contain objects with id and name
    const fieldsToExtractIds = [
      'interest',
      'values',
      'alcoholConsumption',
      'smoker',
      'iUsuallyWakeUpAt',
      'hobbies',
      'fitness',
      'personality',
      'lifeGoals',
      'maxionGoals',
      'meetVibes',
    ];

    fieldsToExtractIds.forEach((field) => {
      if (cleanedFilters[field] && Array.isArray(cleanedFilters[field])) {
        cleanedFilters[field] = cleanedFilters[field].map((item: any) => {
          return typeof item === 'object' && item.id ? item.id : item;
        });
      }
    });

    // Add tierName for tier2 case
    if (this.userStatus === 'tier2') {
      cleanedFilters.tierName = 'TIER2';
    }

    return cleanedFilters;
  }

  // Helper method to generate filter chips for display
  getActiveFilterChips(): Array<{
    key: string;
    label: string;
    value: string[] | string;
  }> {
    const chips: Array<{
      key: string;
      label: string;
      value: string[] | string;
    }> = [];

    if (!this.filterData) return chips;

    const filters = this.filterData;

    console.log('filters', filters);

    // Religion
    if (
      filters.religion &&
      Array.isArray(filters.religion) &&
      filters.religion.length > 0
    ) {
      chips.push({
        key: 'religion',
        label: 'Religion',
        value: filters.religion,
      });
    }

    // Age Range
    if (filters.ageMin !== null || filters.ageMax !== null) {
      chips.push({
        key: 'ageRange',
        label: 'Age',
        value: `${filters.ageMin ?? 'Any'} - ${filters.ageMax ?? 'Any'}`,
      });
    }

    // Nationality
    if (
      filters.nationality &&
      Array.isArray(filters.nationality) &&
      filters.nationality.length > 0
    ) {
      chips.push({
        key: 'nationality',
        label: 'Nationality',
        value: filters.nationality,
      });
    }

    // Marital Status
    if (
      filters.maritalStatus &&
      Array.isArray(filters.maritalStatus) &&
      filters.maritalStatus.length > 0
    ) {
      chips.push({
        key: 'maritalStatus',
        label: 'Marital Status',
        value: filters.maritalStatus,
      });
    }

    // Gender
    if (filters.gender && filters.gender.trim() !== '') {
      chips.push({
        key: 'gender',
        label: 'Gender',
        value: filters.gender,
      });
    }

    // Interests
    if (
      filters.interest &&
      Array.isArray(filters.interest) &&
      filters.interest.length > 0
    ) {
      // Use the names if they exist in the filter data, otherwise use IDs
      const selectedNames = filters.interest.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'interest',
        label: 'Interests',
        value: selectedNames,
      });
    }

    // Values
    if (
      filters.values &&
      Array.isArray(filters.values) &&
      filters.values.length > 0
    ) {
      const selectedNames = filters.values.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'values',
        label: 'Values',
        value: selectedNames,
      });
    }

    // Alcohol Consumption
    if (
      filters.alcoholConsumption &&
      Array.isArray(filters.alcoholConsumption) &&
      filters.alcoholConsumption.length > 0
    ) {
      const selectedNames = filters.alcoholConsumption.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'alcoholConsumption',
        label: 'Alcohol',
        value: selectedNames,
      });
    }

    // Smoking
    if (
      filters.smoker &&
      Array.isArray(filters.smoker) &&
      filters.smoker.length > 0
    ) {
      const selectedNames = filters.smoker.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'smoker',
        label: 'Smoking',
        value: selectedNames,
      });
    }

    // Children
    if (
      filters.children &&
      Array.isArray(filters.children) &&
      filters.children.length > 0
    ) {
      chips.push({
        key: 'children',
        label: 'Children',
        value: filters.children,
      });
    }

    // Wakeup Time
    if (
      filters.iUsuallyWakeUpAt &&
      Array.isArray(filters.iUsuallyWakeUpAt) &&
      filters.iUsuallyWakeUpAt.length > 0
    ) {
      const selectedNames = filters.iUsuallyWakeUpAt.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'iUsuallyWakeUpAt',
        label: 'Wakeup Time',
        value: selectedNames,
      });
    }

    // Profile Step No
    if (
      filters.profileStepNo?.min !== null ||
      filters.profileStepNo?.max !== null
    ) {
      chips.push({
        key: 'profileStepNo',
        label: 'Profile Step',
        value: `${filters.profileStepNo?.min ?? 'Any'} - ${filters.profileStepNo?.max ?? 'Any'}`,
      });
    }

    // Signup Step No
    if (
      filters.signupStepNo?.min !== null ||
      filters.signupStepNo?.max !== null
    ) {
      chips.push({
        key: 'signupStepNo',
        label: 'Signup Step',
        value: `${filters.signupStepNo?.min ?? 'Any'} - ${filters.signupStepNo?.max ?? 'Any'}`,
      });
    }

    // Passport Verified
    if (filters.passportVerified && filters.passportVerified.trim() !== '') {
      chips.push({
        key: 'passportVerified',
        label: 'Passport',
        value: filters.passportVerified,
      });
    }

    // Subscription Status
    if (
      filters.subscriptionStatus &&
      Array.isArray(filters.subscriptionStatus) &&
      filters.subscriptionStatus.length > 0
    ) {
      chips.push({
        key: 'subscriptionStatus',
        label: 'Subscription',
        value: filters.subscriptionStatus,
      });
    }

    // No Matches in Last Days
    if (filters.noMatchesInLastDays && filters.noMatchesInLastDays > 0) {
      chips.push({
        key: 'noMatchesInLastDays',
        label: 'No Matches',
        value: `${filters.noMatchesInLastDays} days`,
      });
    }

    // Hobbies
    if (
      filters.hobbies &&
      Array.isArray(filters.hobbies) &&
      filters.hobbies.length > 0
    ) {
      const selectedNames = filters.hobbies.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'hobbies',
        label: 'Hobbies',
        value: selectedNames,
      });
    }

    // Fitness
    if (
      filters.fitness &&
      Array.isArray(filters.fitness) &&
      filters.fitness.length > 0
    ) {
      const selectedNames = filters.fitness.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'fitness',
        label: 'Fitness',
        value: selectedNames,
      });
    }

    // Personality
    if (
      filters.personality &&
      Array.isArray(filters.personality) &&
      filters.personality.length > 0
    ) {
      const selectedNames = filters.personality.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'personality',
        label: 'Personality',
        value: selectedNames,
      });
    }

    // Life Goals
    if (
      filters.lifeGoals &&
      Array.isArray(filters.lifeGoals) &&
      filters.lifeGoals.length > 0
    ) {
      const selectedNames = filters.lifeGoals.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'lifeGoals',
        label: 'Life Goals',
        value: selectedNames,
      });
    }

    // Maxion Goals
    if (
      filters.maxionGoals &&
      Array.isArray(filters.maxionGoals) &&
      filters.maxionGoals.length > 0
    ) {
      const selectedNames = filters.maxionGoals.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'maxionGoals',
        label: 'Maxion Goals',
        value: selectedNames,
      });
    }

    // Meet Vibes
    if (
      filters.meetVibes &&
      Array.isArray(filters.meetVibes) &&
      filters.meetVibes.length > 0
    ) {
      const selectedNames = filters.meetVibes.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      chips.push({
        key: 'meetVibes',
        label: 'Meet Vibes',
        value: selectedNames,
      });
    }

    return chips;
  }
}
